



























import { Component, Vue, Prop } from "vue-property-decorator";

import { Plants, Plant, Border, Zone, BorderNames } from "@/types";
import { className } from "@/utilities";

import PlantGroup from "@/components/PlantGroup.vue";
import ZoneBackground from "@/components/ZoneBackground.vue";

@Component({
  components: {
    PlantGroup,
    ZoneBackground,
  },
})
export default class BorderView extends Vue {
  get zone(): Zone {
    const zone = this.$route.params.zone;
    return this.$store.state.garden.zones[zone];
  }

  get border(): Border {
    const border = this.$route.params.border as BorderNames;
    return this.zone.borders[border]!;
  }

  get zoneClassName() {
    return className(this.zone!.alias!);
  }

  get plants() {
    return this.border.plants
      .map((number) => {
        const plant = this.$store.state.plants[number];
        if (plant) {
          return {
            ...plant,
            link: `/tuin/${this.$route.params.zone}/${
              this.$route.params.border
            }/${number}`,
          };
        }
        return null;
      })
      .filter((a) => a);
  }
}
